<template>
  <div class="login container">

    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>

    <form v-else @submit.prevent="$nextTick(submit)">

      <div class="d-flex justify-content-between">
        <div class="col-xs-6 pl-3 pt-5">
          <cta link="payment" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>


        <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="unique_code == '' || errors.has('unique_code')" margin="no-margin" :loading="submitted" />
        </div>
      </div>
        
        <div class="row">
          <h2 class="col-md-12 pt-2">Enter card unique code</h2>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="field col-sm-12 pt-4 size-limit">
              <text-input :allowModelSet="true" v-model="unique_code" placeholder="Enter unique code" name="unique_code" v-validate="'required'"  />
          </div>
        </div>


    </form>

    <div v-if="sellCardPermission()" class="row">
      <div class="col-md-12">
        <qr-scanner @decode="onDecode" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){
      return {
          submitted     : false,
          unique_code   : ''
      };
  },
  created:function(){

},
  computed: {

    orderPayload(){
        return this.$store.getters.getOrderPayload;
    },

  },
  watch:{


  },
  mounted: function(){

  },
  methods:{

    /*
    * Decode QR code
    */
    onDecode(decodedString) {
        this.unique_code = decodedString;
    },

    submit()
    {
        this.errors.clear();

        this.$validator.validateAll().then((result) => {
          if(result){
            this.$set(this.orderPayload, 'unique_code', this.unique_code);
            this.$store.commit("ORDER_PAYLOAD",this.orderPayload);
            this.$router.push({ name: 'receipt'});    
          }
        });
    },

  }
}
</script>

<style scoped>

  .select-holder {
    margin-top: 15px;
  }

</style>
